import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/FlightResult.css";
import ReactHtmlParser from "react-html-parser";
import { getHangChoChange, moneyFormatComma } from "../../helpers/function_helper";

export default function FlightResult({
  passengerCounts,
  dataChuyenBayDefault,
  setFlightSelected,
  selectedFlight,
  checkedStop,
  checkedAirline,
  socketDisconnected
}) {
  const [openIdx, setOpenIdx] = useState(null);
  const [dataChuyenBay, setDataChuyenbay] = useState([]);

  useEffect(() => {
    const filtered = dataChuyenBayDefault.filter((item) => {
      if (
        checkedStop.length > 0 &&
        !checkedStop.includes(item.chi_tiet_chang_bay.length.toString())
      ) {
        return false;
      }
      if (
        checkedAirline.length > 0 &&
        !checkedAirline.includes(item.hang_bay.ma)
      ) {
        return false;
      }
      return true;
    });
    setDataChuyenbay(filtered);
  }, [checkedStop, checkedAirline, dataChuyenBayDefault]);

  const navigate = useNavigate();

  const handleBookNow = (flight) => {
    // Lấy lại item mới nhất từ dataChuyenBay để đảm bảo tuy_chon_gia_ve_mac_dinh đúng
    const selected = dataChuyenBay.find((f) => f.uuid === flight.uuid);
    console.log(selected)
    setFlightSelected(selected);
  };

  // Hàm render policy content cho từng chuyến bay
  const renderPolicyContent = (item) => (
    <div className="flight-details-wrapper">
      {item.chi_tiet_chang_bay.map((segment, i) => (
        <div key={i} className="flight-detail-card">
          {/* Timeline giờ */}
          <div className="flight-timeline">
            <div className="timeline-departure">
              <div className="timeline-time">{segment.gio_di}</div>
              <div className="timeline-date">{segment.ngay_di?.replaceAll("-", "/")}</div>
            </div>
            <div className="timeline-spacer"></div>
            <div className="timeline-duration">
              {/* <div className="timeline-time">{segment.thoi_gian_bay}</div> */}
            </div>
            <div className="timeline-spacer"></div>
            <div className="timeline-arrival">
              <div className="timeline-time">{segment.gio_den}</div>
              <div className="timeline-date">{segment.ngay_den?.replaceAll("-", "/")}</div>
            </div>
          </div>

          {/* Line + chấm */}
          <div className="flight-line-wrapper">
            <div className="flight-circle"></div>
            <div className="flight-line"></div>
            <div className="flight-circle end"></div>
          </div>

          {/* Nội dung */}
          <div className="flight-content-detail">
            <div className="departure-airport">
              <div className="airport-name">{segment.diem_di.tinh} ({segment.diem_di.ma})</div>
              <div className="airport-sub">{segment.diem_di.ten}</div>
            </div>

            <div className="flight-airline">
              <span>{item.hang_bay.ten} · {segment.so_hieu}</span>
            </div>
            <div className="flight-aircraft">✈ {segment.loai_may_bay}</div>

            {/* Thông tin từ dieu_kien_ve_v2 */}
            <div className="flight-amenities">
              {ReactHtmlParser(
                item.dieu_kien_ve?.[item.tuy_chon_gia_ve_mac_dinh?.index]
              )}
            </div>

            <div className="arrival-airport">
              <div className="airport-name">{segment.diem_den.tinh} ({segment.diem_den.ma})</div>
              <div className="airport-sub">{segment.diem_den.ten}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="flights-container">
      {dataChuyenBay.map((item, idx) => (
        <div key={item.uuid} className="flight-item">
          <div className="flight-content">
            {/* Logo và tên hãng bay */}
            <div className="airline-section">
              <div className="airline-logo">
                <img src={item.hang_bay.logo} alt={item.hang_bay.ten} />
              </div>
              <div className="airline-name">{item.so_hieu}</div>
            </div>

            {/* Thông tin tuyến bay */}
            <div className="route-section">
              <div className="route-details">
                <div className="departure">
                  <div className="time-large">{item.gio_di}</div>
                  <div className="airport-code">{item.diem_di.ma}</div>
                </div>

                <div className="flight-path">
                  <div className="duration">
                    <div className="time">{item.thoi_gian_bay}</div>
                    <div className="line-text">
                      <span>
                        {(item.chi_tiet_chang_bay.length - 1) === 0 
                          ? "Bay thẳng" 
                          : `${item.chi_tiet_chang_bay.length - 1} điểm dừng`
                        }
                      </span>
                    </div>
                  </div>
                </div>

                <div className="arrival">
                  <div className="time-large">{item.gio_den}</div>
                  <div className="airport-code">{item.diem_den.ma}</div>
                </div>
              </div>

              {/* Promotion Tags */}
              {item.khuyen_mai && item.khuyen_mai.length > 0 && (
                <div className="promotion-tags">
                  {item.khuyen_mai.slice(0, 2).map((promo, idx) => (
                    <span key={idx} className="promo-tag">
                      {promo}
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* Giá tiền */}
            <div className="price-section">
              {/* Hiển thị giá gốc nếu cao hơn giá đại lý */}
              {item.tuy_chon_gia_ve_mac_dinh.nguoi_lon.gia_hien_thi > item.tuy_chon_gia_ve_mac_dinh.nguoi_lon.gia_dai_ly && (
                <div className="original-price">
                  {moneyFormatComma(item.tuy_chon_gia_ve_mac_dinh.nguoi_lon.gia_hien_thi)}
                </div>
              )}
              
              <div className="final-price">
                {moneyFormatComma(item.tuy_chon_gia_ve_mac_dinh.nguoi_lon.gia_dai_ly)}
                <span className="per-passenger">/khách</span>
              </div>
            </div>
          </div>

          {/* Dòng thứ 2: Tabs và nút chọn */}
          <div className="flight-actions">
            <div className="details-tabs">
              <button 
                className={`tab-btn ${openIdx === idx ? 'active' : ''}`}
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                Chi tiết
              </button>
            </div>
            
            <button
              className={`select-btn ${selectedFlight?.uuid === item.uuid ? 'selected' : ''}`}
              onClick={() => handleBookNow(item)}
            >
              Chọn
            </button>
          </div>

          {/* Expanded Details */}
          {openIdx === idx && (
            <div className="expanded-details">
              {renderPolicyContent(item)}
            </div>
          )}
        </div>
      ))}
      
      {/* Chưa ngắt socket - đang tải thêm chuyến bay */}
      {!socketDisconnected && (
        <div className="loadmore-loading">
          <div className="spinner-border text-primary mb-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <div>Đang tải thêm chuyến bay...</div>
        </div>
      )}
      
      {/* Đã ngắt socket - hiển thị tổng số chuyến bay */}
      {socketDisconnected && dataChuyenBay.length > 0 && (
        <div className="loadmore-complete">
          <i className="fas fa-check-circle me-2"></i>
          Đã hiển thị tất cả {dataChuyenBay.length} chuyến bay
        </div>
      )}
    </div>
  );
}
